import { QueryClient } from '@tanstack/react-query';

import { toApiError } from '@/api/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Reintentar un 401/403/404 nunca cambia el resultado.
        const status = toApiError(error).status;
        if (status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

/** Claves de caché centralizadas para no invalidar por strings sueltos. */
export const queryKeys = {
  me: ['me'] as const,
  dashboard: ['dashboard'] as const,
  stats: ['stats'] as const,
  activeGame: ['game', 'active'] as const,
  gameQuestion: (sessionId: number) => ['game', sessionId, 'question'] as const,
  gameHistory: (page: number) => ['game', 'history', page] as const,
  leaderboard: (filters: Record<string, unknown>) => ['leaderboard', filters] as const,
  levels: ['levels'] as const,
  levelsWithStats: ['levels', 'stats'] as const,
  questions: (filters: Record<string, unknown>) => ['questions', filters] as const,
  adminDashboard: ['admin', 'dashboard'] as const,
  adminUsers: (filters: Record<string, unknown>) => ['admin', 'users', filters] as const,
};
